import { takeLatest, put, call, fork } from "redux-saga/effects";
import { CaseNoteService } from "services";
import {
    fetchCaseNotes,
    fetchedCaseNotes,
    failedFetchCaseNotes,
    createdCaseNote,
    failedCreateCaseNote,
    deletedCaseNote,
    failedDeleteCaseNote,
    retrievedCaseNote,
    failedRetrieveCaseNote
} from "actions/case-note-actions";

import { CASE_NOTE_ACTIONS } from "constants/actions";

function* createCaseNote({ payload: { case_id, note_id, note } }) {
    try {
        const { data, error } = yield call(
            CaseNoteService.addCaseNote,
            note.formValues
        );
        if (!error) {
            yield put(
                createdCaseNote(case_id, null, note_id, {
                    ...data,
                    case: data.case.id
                })
            );
            // yield put(fetchCaseNotes(case_id));
        } else {
            yield put(failedCreateCaseNote(case_id, note_id, note, error));
        }
    } catch(error) {
        yield put(failedCreateCaseNote(case_id, note_id, note, error));
    }
}

function* fetchCaseNotesHandler({ payload: { case_id } }) {
    try {
        const { data, error } = yield call(CaseNoteService.fetchCaseNotes, case_id);

        if (!error) {
            yield put(fetchedCaseNotes(case_id, data));
        } else {
            yield put(failedFetchCaseNotes(case_id, error));
        }
    } catch(error) {
        yield put(failedFetchCaseNotes(case_id, error));
    }
}

function* deleteCaseNotes({ payload }) {
    try {
        const { data, error } = yield call(CaseNoteService.deleteCaseNote, payload);

        if (data) {
            yield put(deletedCaseNote(payload.case_id, payload.case_note_id));
            yield put(fetchCaseNotes(payload.case_id));
        } else {
            yield put(failedDeleteCaseNote(payload.case_id, payload.case_note_id, error));
        }
    } catch(error) {
        yield put(failedDeleteCaseNote(payload.case_id, payload.case_note_id, error));
    }
}

function* retrieveCaseNotes({ payload }) {
    try {
        const { data, error } = yield call(CaseNoteService.retrieveCaseNote, payload);

        if (data) {
            yield put(retrievedCaseNote(payload.case_id, payload.case_note_id));
            yield put(fetchCaseNotes(payload.case_id));
        } else {
            yield put(failedRetrieveCaseNote(payload.case_id, payload.case_note_id, error));
        }
    } catch(error) {
        yield put(failedRetrieveCaseNote(payload.case_id, payload.case_note_id, error));
    }
}

export default fork(function*() {
    yield takeLatest(CASE_NOTE_ACTIONS.CREATE_CASE_NOTE, createCaseNote);
    yield takeLatest(CASE_NOTE_ACTIONS.FETCH_CASE_NOTES, fetchCaseNotesHandler);
    yield takeLatest(CASE_NOTE_ACTIONS.DELETE_CASE_NOTE, deleteCaseNotes);
    yield takeLatest(CASE_NOTE_ACTIONS.RETRIEVE_CASE_NOTE, retrieveCaseNotes);
});
